<!--
	Skeleton for the data-source cards (Bucket / Drive / Gateway), rendered in each
	card's v-else. Reuses the real .entity-card / __header / __body / __meta /
	__actions layout so spacing/structure changes to the cards propagate here
	automatically — only the SkeletonBlock widths are card-specific.

	Callers override the variant-specific pieces via the #pills, #text, and #actions
	slots. Defaults match DriveCard's layout. Pass :trailingAction="false" for
	footers without the trailing disconnect button (e.g. GatewayCard).
-->
<template>
	<div class="entity-card">
		<div class="entity-card__header">
			<SkeletonBlock
				width="var(--sgnl-icon-32)"
				height="var(--sgnl-icon-32)"
			/>
			<div class="sgnl-flex sgnl-align-center">
				<SkeletonBlock
					width="60%"
					class="sgnl-paragraph-m-medium"
				/>
			</div>
		</div>
		<div class="entity-card__body">
			<div class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8">
				<slot name="pills">
					<SkeletonBlock
						width="110px"
						height="22px"
						radius="var(--sgnl-border-radius-6)"
					/>
				</slot>
			</div>
			<div class="entity-card__meta sgnl-paragraph-s-regular">
				<slot name="text">
					<div
						v-if="!$vuetify.display.mobile"
						class="sgnl-flex sgnl-align-center"
					>
						<SkeletonBlock width="55%" />
					</div>
					<div class="sgnl-flex sgnl-align-center">
						<SkeletonBlock width="45%" />
					</div>
				</slot>
			</div>
		</div>
		<div class="entity-card__actions">
			<slot name="actions">
				<SkeletonBlock
					width="175px"
					btn
				/>
			</slot>
			<template v-if="trailingAction">
				<v-spacer />
				<SkeletonBlock
					width="var(--sgnl-unit-64)"
					btn
				/>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SkeletonBlock from "@/components/Common/SkeletonBlock.vue";

export default defineComponent({
	name: "DataSourceCardSkeleton",
	components: { SkeletonBlock },
	props: {
		trailingAction: { type: Boolean, default: true },
	},
});
</script>
